import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isMarkActive, toggleMarkCommand } from '../utils/markUtils';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import UITextToolbarIcon from 'rich-text-lib/components/editor/UITextToolbarIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const toggleStrike = toggleMarkCommand(schema => schema.marks.strikethrough);
export default function StrikeMark() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const toggleStrikeMark = useCallback(e => {
    e.preventDefault();
    toggleStrike(editorState, tr => setEditorState(editorState.apply(tr)));
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.strikethrough"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      onMouseDown: toggleStrikeMark,
      "data-test-id": "strikethrough",
      selected: editorState && hasStrikethrough(editorState),
      children: /*#__PURE__*/_jsx(UITextToolbarIcon, {
        name: "strike"
      })
    })
  });
}
function hasStrikethrough(state) {
  return isMarkActive(state, state.schema.marks.strikethrough);
}